import { render, staticRenderFns } from "./NewProductSlider.vue?vue&type=template&id=ea477ac6&scoped=true&"
import script from "./NewProductSlider.vue?vue&type=script&lang=js&"
export * from "./NewProductSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewProductSlider.vue?vue&type=style&index=0&id=ea477ac6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea477ac6",
  null
  
)

export default component.exports